import { render } from "./ViewInvites.vue?vue&type=template&id=7ce56540&scoped=true"
import script from "./ViewInvites.vue?vue&type=script&lang=js"
export * from "./ViewInvites.vue?vue&type=script&lang=js"

import "./ViewInvites.vue?vue&type=style&index=0&id=7ce56540&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ce56540"]])

export default __exports__